import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { requiresSetup } from "../../utils/setupAccess";
import AccountSetup from "../../pages/auth/AccountSetup";

// Do not mount product providers, SIP, or dashboards while awaiting approval.
export default function SetupAccessBoundary({ children }) {
  const { user, isLoaded } = useAuth();
  const { pathname } = useLocation();

  if (isLoaded && requiresSetup(user)) {
    return pathname === "/setup" ? (
      <AccountSetup />
    ) : (
      <Navigate to="/setup" replace />
    );
  }

  return children;
}
